import { ROUTES } from '@/shared/constants/routes';
import type { PresentationKind, PresentationSection } from '@/viewmodel/features/dashboard/types';

const SECTION_KIND: Record<PresentationSection, PresentationKind> = {
  presentations: 'deck',
  documents: 'report',
  videos: 'video',
};

const SECTION_ROUTE: Record<PresentationSection, string> = {
  presentations: ROUTES.PRESENTATIONS,
  documents: ROUTES.DOCUMENTS,
  videos: ROUTES.VIDEOS,
};

const STAFF_ONLY: ReadonlySet<PresentationSection> = new Set<PresentationSection>(['videos']);

export function studioSectionOpen(section: PresentationSection, isStaff: boolean): boolean {
  return isStaff || !STAFF_ONLY.has(section);
}

function under(pathname: string, route: string): boolean {
  return pathname === route || pathname.startsWith(`${route}/`);
}

export function studioSectionOf(pathname: string): PresentationSection {
  if (under(pathname, ROUTES.DOCUMENTS)) return 'documents';
  if (under(pathname, ROUTES.VIDEOS)) return 'videos';

  return 'presentations';
}

export function studioSectionKind(section: PresentationSection): PresentationKind {
  return SECTION_KIND[section];
}

export function studioSectionRoute(section: PresentationSection): string {
  return SECTION_ROUTE[section];
}

export function studioSectionKey(section: PresentationSection, key: string): string {
  return section === 'presentations'
    ? `presentationsPage.${key}`
    : `presentationsPage.${section}.${key}`;
}
